import { getCartProductsApi } from "src/services/CartApi";
import { addToCart, deleteAllFromCart } from "src/store/slices/cart-slice";
import { addToCartAsync } from "src/store/slices/cartThunks";
import { store } from "src/store/store";

export const handleAddToCart = async (
  selectedVariant,
  product,
  quantityCount,
  showToastMessage,
  accessToken,
  slotId,
  selectedSlot
) => {
  const finalProduct = {
    ...product,
    quantityCount,
    showToastMessage,
  };

  if (selectedVariant) {
    finalProduct.price = selectedVariant.price;
    finalProduct.variantId = selectedVariant.ID;
    finalProduct.variantName = selectedVariant.name;
  }

  if (slotId && selectedSlot) {
    finalProduct.slotId = slotId;
    
    // Always generate the slot name from the selected slot
    // This ensures consistency between client and server
    const startTime = new Date(selectedSlot.startTime);
    const timeString = `${startTime.getDate().toString().padStart(2, '0')}/${(startTime.getMonth() + 1).toString().padStart(2, '0')} ${startTime.getHours().toString().padStart(2, '0')}:${startTime.getMinutes().toString().padStart(2, '0')}`;
    
    // Use the generated time string as variantName for display
    finalProduct.variantName = timeString;
  }

  if (selectedVariant) {
    store.dispatch(
      addToCartAsync(
        finalProduct,
        quantityCount,
        finalProduct.variantId,
        accessToken,
        slotId
      )
    );
  } else {
    // Create the product object with all necessary data
    const productWithSlotData = {
      ...product,
      quantityCount,
      showToastMessage,
      ...(slotId && { slotId }),
    };
    
    // Always add variantName if it exists
    if (finalProduct.variantName) {
      productWithSlotData.variantName = finalProduct.variantName;
    }
    
    
    store.dispatch(
      addToCartAsync(
        productWithSlotData,
        quantityCount,
        null,
        accessToken,
        slotId
      )
    );
  }
};

export const updateLocalCartFromServerOnLoad = async (accessToken) => {
  if (!accessToken) return Promise.resolve();
  store.dispatch(deleteAllFromCart());
  const serverCart = await getCartProductsApi();
  for (let i = 0; i < serverCart.length; i++) {
    let product = serverCart[i];
    store.dispatch(
      addToCart({
        ...product,
        name: product.productName,
        ID: product.productId,
        showToastMessage: false,
        quantityCount: product.quantity,
      })
    );
  }
};
